import {
  CLIENT_ACTIONS,
  ERROR_ACTIONS,
  PROJECT_ACTIONS,
  LICENSE_ACTIONS,
  KNOWN_FILES_ACTIONS,
  TEMPLATE_ACTIONS,
  SETTINGS_ACTIONS,
  BACKUP_ACTIONS,
  APPLICATION_STATE_ACTIONS,
  IMAGE_CACHE_ACTIONS,
  NOTIFICATION_ACTIONS,
  DOM_EVENT_ACTIONS,
  TESTING_AND_DIAGNOSIS_ACTIONS,
  SET_USER_ID,
  UNDO_ACTIONS,
  OFFLINE_ACTIONS,
  IDEA_ACTIONS,
  AUDIO_CACHE_ACTIONS,
} from '../constants/ActionTypes'

export const SYSTEM_REDUCER_KEYS = [
  'error',
  'permission',
  'project',
  'actions',
  'client',
  'license',
  'knownFiles',
  'templates',
  'settings',
  'backups',
  'applicationState',
  'imageCache',
  'notifications',
  'domEvents',
  'testingAndDiagnosis',
  'editors',
  'ideas',
  'audioCache',
]
export const SYSTEM_REDUCER_ACTION_TYPES = ERROR_ACTIONS.concat(PROJECT_ACTIONS)
  .concat(CLIENT_ACTIONS)
  .concat(LICENSE_ACTIONS)
  .concat(KNOWN_FILES_ACTIONS)
  .concat(TEMPLATE_ACTIONS)
  .concat(SETTINGS_ACTIONS)
  .concat(BACKUP_ACTIONS)
  .concat(APPLICATION_STATE_ACTIONS)
  .concat(IMAGE_CACHE_ACTIONS)
  .concat(NOTIFICATION_ACTIONS)
  .concat(DOM_EVENT_ACTIONS)
  .concat(TESTING_AND_DIAGNOSIS_ACTIONS)
  .concat(SET_USER_ID)
  .concat(UNDO_ACTIONS)
  .concat(OFFLINE_ACTIONS)
  .concat(IDEA_ACTIONS)
  .concat(AUDIO_CACHE_ACTIONS)

/**
 * @typedef {import('../index').PlottrFile} PlottrFile
 */

/**
 * @param {PlottrFile} jsonData
 * @return {PlottrFile}
 */
export const removeSystemKeys = (jsonData) => {
  /**
   * @type {PlottrFile}
   */
  const withoutSystemKeys = Object.assign({}, jsonData)
  Object.keys(jsonData).map((key) => {
    if (SYSTEM_REDUCER_KEYS.indexOf(key) >= 0) {
      delete withoutSystemKeys[key]
    }
  })
  return withoutSystemKeys
}
